export function isNullOrUndefined(x: any) {
    return x === null || x === undefined;
}